const config = useRuntimeConfig();

export const stat = {
  getStat: createUseApi<
    {
      page: number;
      limit: number;
      sortData: {
        sortField: string;
        sortOrder: string;
      };
      dateRange: Date[];
      userEmail: string;
    } | void,
    {
      data: StatInfoDto[];
      meta: {
        total: number;
      };
    }
  >({
    url: `${config.public.url}/stat`,
    method: "GET",
    queryBuilder: (input) => {
      if (!input) return { page: 0, limit: 10 };
      else {
        return {
          page: input.page,
          limit: input.limit,
          orderBy: input?.sortData.sortField,
          order: input?.sortData.sortOrder,
          createdAtFrom: input?.dateRange[0].toISOString(),
          createdAtTo: input?.dateRange[1].toISOString(),
          userEmail: input?.userEmail,
        };
      }
    },
    requireAuthentication: true,
  }),
  getCounts: createUseApi<void, StatInfoCountDto>({
    url: `${config.public.url}/stat/count`,
    method: "GET",
    requireAuthentication: true,
  }),
  getVisitsCount: createUseApi<string[], number>({
    url: (input) =>
      `${config.public.url}/stat/getVisitsCount?startDate=${input[0]}&endDate=${input[1]}`,
    method: "GET",
    requireAuthentication: true,
  }),
};

export interface StatInfoDto {
  id: string;
  dataFields: {
    title: string;
    value: string;
  }[];
  status: boolean;
  registrationDate: Date;
}

export interface StatInfoCountDto {
  countOfInvoices: number;
  countOfAnnouncements: number;
  getWeeklyVisits: number;
  getMonthlyVisits: number;
  getThreeMonthlyVisits: number;
  getSixMonthlyVisits: number;
  getYearlyVisits: number;
  getAllTimeVisits: number;
}
